import styled from "styled-components";

import materialUI from "../../../material-UI";
import color from "../../../constants/color";

export const Container = styled.div`
  margin-top: 1rem;
`;

export const RowIndicators = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: #ffffff;
  min-height: 300px;
  padding: 32px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
`;

export const Tabs = styled(materialUI.Tabs)`
  color: ${color.almostBlack};
  font-family: Inter;
  background-color: ${color.white};
  border-top-right-radius: 8px;
  border-bottom: 1px solid #d2d8e8;
  border-top-left-radius: 8px;
  width: 100%;
`;
export const Tab = styled(materialUI.Tab)`
  font-family: Inter-Medium;
  height: 54px;
  color: ${color.Almostblack};
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.015em;
  padding: 16px 32px;
  width: 33.333%;
  max-width: unset;
  opacity: 1;

  &.task-tab {
    width: 50%;
  }

  &.MuiTab-textColorInherit.Mui-selected {
    color: ${color.primary};
  }
`;
export const Box = styled(materialUI.Box)``;
